export default {
	field: 'partClass.description',
	name: 'Description',
}
